import { Stack, Tab, Tabs, Tooltip, Typography, ClickAwayListener } from '@mui/material'
import { Box } from '@mui/system'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useUser } from 'store'
import ScrollableContent from 'packages/ui/ScrollableContent'
import SitesSelection from './Sites'

import ModalPicture from './ModalPicture'


const Content = ({ content, image }) => {
  const { t } = useTranslation()
  const [fullScreen, setFullScreen] = useState(false)
  const [user] = useUser()

  return (
    <ScrollableContent>
      <Stack gap={1} width={'100%'} color={'grey.500'}>
        <Typography fontWeight={500} fontSize={14} color={'grey.900'}>
          {content.header}
        </Typography>
        <Typography color={'grey.600'} fontSize={14}>
          {content.body}
        </Typography>
        <Box display={'flex'} justifyContent={'end'} padding={1}>
          <Typography fontStyle={'italic'} fontSize={12}>
            {content.footer}
          </Typography>
        </Box>
        {image && (
          <Box mt={2} display={'flex'} justifyContent={'center'}>
            <Box 
              position={'relative'} 
              onClick={() => setFullScreen(true)} 
              sx={{ cursor: 'pointer' }}
            >
              <img style={{ borderRadius: 6, maxWidth: '400px', maxHeight: '280px', ...(user.demo_mode && { filter: 'blur(16px)' }) }} src={image.dataURL} />
              <Box position={'absolute'} bottom={0} right={0}>
                <Box
                  backgroundColor={'black'}
                  sx={{
                    opacity: 0.8,
                    cursor: 'pointer',
                    padding: '2px 8px',
                    borderTopLeftRadius: 4
                  }}>
                  <Tooltip title={t('advertisements.card.tooltip_fullscreen_picture')} placement={'top'}>
                    <i className="fa-regular fa-expand-wide" style={{ color: 'white' }} />
                  </Tooltip>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {fullScreen && (
          <ModalPicture onClose={() => !setFullScreen()}>
            <ClickAwayListener onClickAway={() => !setFullScreen()}>
              <img style={{ maxHeight: '800px' }} src={image.dataURL} />
            </ClickAwayListener>
          </ModalPicture>
        )}
      </Stack>
    </ScrollableContent>
  )
}

const Body = ({ advertisement }) => {
  const { t } = useTranslation()

  const [selectedTab, setSelectedTab] = useState()

  const languageTab = useMemo(() => {
    const activeLanguage = advertisement.contents.filter(({ body }) => body.length).map(content => content.language)
    setSelectedTab(activeLanguage[0])
    return activeLanguage
  }, [advertisement])

  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'} minHeight={0}>
      <Tabs value={selectedTab} onChange={(e, value) => setSelectedTab(value)} sx={{ flexShrink: 0 }}>
        {languageTab.map(language => (
          <Tab className="uppercase" component={'div'} key={language} label={language} value={language} />
        ))}
        <Tab
          component={'div'}
          value={'sites'}
          display={'flex'}
          sx={{ marginLeft: 'auto' }}
          label={
            <Stack direction="row" alignItems={'center'} gap={1}>
              {t('advertisements.card.tabs.sites')}
              <Box
                bgcolor={'grey.100'}
                color={'grey.600'}
                sx={{
                  padding: '2px 6px',
                  borderRadius: '0.5rem',
                  marginLeft: 'auto'
                }}>
                {advertisement.count_sites}
              </Box>
            </Stack>
          }
        />
      </Tabs>
      {selectedTab === 'sites' ? (
        <SitesSelection accounts={advertisement.accounts} hasAlertPerimeter={!advertisement.can_be_edit} />
      ) : (
        <Content
          content={advertisement.contents.find(content => content.language === selectedTab)}
          image={advertisement.image}
        />
      )}
    </Box>
  )
}

export default Body
